// extracted by mini-css-extract-plugin
export default {"interesseContainer":"produtoInteresse_interesseContainer__Y6d8Y"};